export default __webpack_public_path__ + "static/media/Ivory_orchids_Jenny_Thomlinson_30_x_40.69f36002.jpg";